import { addFamilyMember } from 'aster-foundation/core/astercore/profile/profile/redux/actions';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { IC_BIG_NO_MEMBERS } from '../../../../public/images';
import CommonSpaceHolder from '../../../Common/Component/CommonSpaceHolder/CommonSpaceHolder';
import { errorHandling, getMyAsterCategory, getReferralPageForGA } from '../../../Common/Utility/common-utils';
import ErrorAlertBanner from '../../../RxHomeDelivery/ErrorAlertBanner/ErrorAlertBanner';
import ExistingFamilyMemberCard from './ExistingFamilyMemberCard';
import ExistingFamilyMemberStyled from './ExistingFamilyMemberStyled';
import { dataLayerAddFamilyMemberError, dataLayerAddFamilyMemberSuccess } from '../../../Common/Utility/analytics-utils';
import { CheckboxControl } from '../../../Common/Component/Forms';
import { useRouter } from 'next/router';
import { ERROR_TYPE, MY_ASTER_CATEGORY, PAGE_TYPE } from '../../../Common/Constants/analytics';
import { getPageTypeForAddFamily, getScreenNameForAddFamily } from '@common/Utility/constants';

const ExistingFamilyMemberSidebar = ({
  noSelectedUser,
  familyMembers,
  primaryButtonClicked,
  setNoSelectedUser,
  setShowExistingProfileView,
  userId,
  notRelatedClicked,
  setShowAddMemberView,
  setPrimaryButtonClicked,
  setNotRelatedClicked,
  getAllProfileData,
  handleClose,
  setSuccess,
  setAddNewUserData,
  showOnlyCheckBox,
  docName,
  screenName,
  pageType,
  doctorId,
  referrerPage,
}) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const [selectedUser, setSelectedUser] = useState(
    familyMembers?.length === 1 ? [{ ...familyMembers[0], isSelectedProfile: true }] : [],
  );
  const doctorName = router?.query?.doctorname;
  const docID = router?.query?.docID;
  const referralPageForGa = router.asPath ? getReferralPageForGA(router.asPath) : 'Aster Core Login ';
  const [errors, setErrors] = useState({});
  const [terms, setTerms] = useState(!showOnlyCheckBox);

  const getProfileCountTitle = () => {
    const profileCount = familyMembers?.length || 0;
    return profileCount === 1 ? 'Profile Found' : `${profileCount} Profiles Found`;
  };

  const handleSelectUser = (data) => {
    const existingUser = selectedUser.find((item) => item.hisSystemId === data.hisSystemId);

    if (!existingUser) {
      if (showOnlyCheckBox) {
        setSelectedUser([...selectedUser, { ...data, isSelectedProfile: true }]);
      } else {
        setSelectedUser([{ ...data, isSelectedProfile: true }]);
        setNoSelectedUser(false);
      }
    } else {
      const tempindex = selectedUser.indexOf(existingUser);
      selectedUser.splice(tempindex, 1);
      setSelectedUser([...selectedUser]);
    }
  };

  const dataLayerForError = (errors) => {
    let errType = '';
    if (errors === 'Something went wrong') {
      errType = ERROR_TYPE.API_ERROR;
    } else {
      errType = ERROR_TYPE.VALIDATION_ERROR;
    }
    dataLayerAddFamilyMemberError(
      doctorName ? doctorName : getScreenNameForAddFamily(router?.pathname),
      getPageTypeForAddFamily(router?.pathname),
      getMyAsterCategory(router?.pathname),
      router?.query?.referrerPage ? `${router?.query?.referrerPage} page` : referralPageForGa,
      errors,
      errType,
      docID,
    );
  };

  const handleRelationshipChange = (e, data) => {
    setNoSelectedUser(false);
    if (selectedUser.length) {
      setSelectedUser(
        selectedUser.map((itm) => {
          if (itm.hisSystemId === data.hisSystemId) {
            return { ...itm, relationship: e.target.value };
          }
          return itm;
        }),
      );
    } else {
      setSelectedUser(
        familyMembers?.map((member) => ({ ...member, isSelectedProfile: true, relationship: e.target.value })),
      );
    }
  };

  const getParams = (memberList) => ({
    id: userId,
    body: memberList,
  });
  const parameter = {
    screen_name: doctorName ? docName : 'asco homepage',
    myaster_category: doctorName ? MY_ASTER_CATEGORY?.DOCTOR_CONSULT : MY_ASTER_CATEGORY?.ASCO,
    page_type: doctorName ? PAGE_TYPE.DDP : PAGE_TYPE.HOME,
  };
  if (docID && doctorName && doctorName !== 'asco homepage') {
    parameter.page_id = docID;
  }
  const handleFamilyMemberAdd = () => {
    const isAllDataFilled = showOnlyCheckBox
      ? selectedUser.every((item) => Object.hasOwnProperty.call(item, 'relationship'))
      : true;

    if (selectedUser.length && terms && isAllDataFilled) {
      setNoSelectedUser(false);
      dispatch(
        addFamilyMember({
          params: getParams(selectedUser),
          onSuccess: (res) => {
            dataLayerAddFamilyMemberSuccess(
              doctorName ? doctorName : getScreenNameForAddFamily(router?.pathname),
              getPageTypeForAddFamily(router?.pathname),
              getMyAsterCategory(router?.pathname),
              router?.query?.referrerPage ? `${router?.query?.referrerPage} page` : referrerPage,
              docID,
            );
            if (!showOnlyCheckBox) {
              getAllProfileData();
              setShowExistingProfileView(false);
              setShowAddMemberView(false);
              setPrimaryButtonClicked(0);
              setNotRelatedClicked(0);
              handleClose();
              setSuccess(true);
              if (res?.body?.length === 1) {
                setAddNewUserData(res?.body[0]);
              }
            } else {
              localStorage.setItem('showLinkedProfiles' ,'false');
              handleClose();
              setSuccess(true);
              setPrimaryButtonClicked(0);
              setNotRelatedClicked(0);
            }
          },
          onFailure: (err) => {
            dataLayerForError(err);
            errorHandling(err);
            setPrimaryButtonClicked(0);
            setNotRelatedClicked(0);
            if (!showOnlyCheckBox) dataLayerForError(err);
          },
        }),
      );
    } else {
      setErrors({
        ...errors,
        terms: !terms ? 'Please accept terms and conditions' : '',
        relation: !selectedUser.every((item) => Object.hasOwnProperty.call(item, 'relationship'))
          ? 'Please select relationship'
          : '',
      });
      if (!terms) {
        dataLayerForError('Please accept terms and conditions');
      }
      if (!selectedUser?.length) {
        dataLayerForError('Please select any profile and relationship to proceed');
      } else if (!selectedUser.every((item) => Object.hasOwnProperty.call(item, 'relationship'))) {
        dataLayerForError('Please select relationship');
      }
      setNoSelectedUser(!selectedUser.length);
    }
  };

  const handleNotFamilyMember = () => {
    dispatch(
      addFamilyMember({
        params: getParams(familyMembers?.map((member) => ({ ...member, isSelectedProfile: false }))),
        onSuccess: () => {
          if (!showOnlyCheckBox) {
            setShowExistingProfileView(false);
            setShowAddMemberView(true);
            setPrimaryButtonClicked(0);
            setNotRelatedClicked(0);
          } else {
            localStorage.setItem('showLinkedProfiles' ,'false');
            handleClose();
          }
        },
        onFailure: (err) => {
          errorHandling(err);
          setPrimaryButtonClicked(0);
          setNotRelatedClicked(0);
        },
      }),
    );
  };

  useEffect(() => {
    if (primaryButtonClicked) {
      handleFamilyMemberAdd();
    }
  }, [primaryButtonClicked]);

  useEffect(() => {
    if (notRelatedClicked) {
      handleNotFamilyMember();
    }
  }, [notRelatedClicked]);

  return (
    <ExistingFamilyMemberStyled isSidebar showOnlyCheckBox>
      <CommonSpaceHolder
        outerCustomClass="aster-link-container"
        icon={IC_BIG_NO_MEMBERS}
        title={getProfileCountTitle()}
        subtitle={
          !showOnlyCheckBox
            ? `We've found ${
                familyMembers?.length > 1 ? 'profiles' : 'profile'
              } linked to the primary user's mobile number. ${
                familyMembers.length > 1
                  ? 'Please select a relevant profile or create a new one.'
                  : 'Proceed with below profile or create a new one'
              }`
            : `${
                familyMembers?.length > 1 ? 'Profiles' : 'Profile'
              } linked to your mobile number found. Please confirm or skip if not yours`
        }
      />
      <div className="existing_member_wrapper">
        {noSelectedUser && <ErrorAlertBanner message="Please select any profile and relationship to proceed" />}
        {familyMembers?.map((member) => (
          <ExistingFamilyMemberCard
            key={member.hisSystemId}
            member={member}
            handleSelectUser={handleSelectUser}
            selectedUser={selectedUser}
            handleRelationshipChange={handleRelationshipChange}
            familyMember={familyMembers}
            isMobile
            isSidebar
            showOnlyCheckBox={showOnlyCheckBox}
            errors={showOnlyCheckBox ? errors : {}}
          />
        ))}
        {showOnlyCheckBox ? (
          <CheckboxControl
            label="I hereby declare that I am lawfully authorized and have permission to access all profile details, records and all reports on behalf of the owner of the information."
            checked={terms}
            data-test="terms"
            onClick={() => {
              setTerms(!terms);
              setErrors({ ...errors, terms: null });
            }}
            isInvalid={!!errors.terms}
            errorMessage={errors.terms}
            className="consentBox"
          />
        ) : (
          <div className="consentText">
            I hereby declare that I am lawfully authorized and have permission to access all profile details, records
            and all reports on behalf of the owner of the information.
          </div>
        )}
      </div>
    </ExistingFamilyMemberStyled>
  );
};

ExistingFamilyMemberSidebar.propTypes = {
  noSelectedUser: PropTypes.bool.isRequired,
  familyMembers: PropTypes.array.isRequired,
  primaryButtonClicked: PropTypes.number.isRequired,
  setNoSelectedUser: PropTypes.func.isRequired,
  setShowExistingProfileView: PropTypes.func.isRequired,
  userId: PropTypes.string.isRequired,
  notRelatedClicked: PropTypes.number.isRequired,
  setShowAddMemberView: PropTypes.func.isRequired,
  setPrimaryButtonClicked: PropTypes.func.isRequired,
  setNotRelatedClicked: PropTypes.func.isRequired,
  getAllProfileData: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  setSuccess: PropTypes.func.isRequired,
  setAddNewUserData: PropTypes.func.isRequired,
  showOnlyCheckBox: PropTypes.bool.isRequired,
};

export default ExistingFamilyMemberSidebar;
